import { setSubroute } from 'store/navbar'
import { injectReducers } from 'store/reducers'
import { browserHistory } from 'utils/navigation'
import { setPageTitle } from 'utils/misc'
import { isSameUser } from 'utils/userUtils'
import ParticipantsPageRoute from './routes/ParticipantsPage'
import CreateParticipantRoute from './routes/CreateParticipant'
import AccountSettingsRoute from './routes/AccountSettings'
import ViewParticipantsRoute from './routes/ViewParticipant'
import CreateCohortRoute from './routes/CreateCohort'
import ViewCohortRoute from './routes/ViewCohort'
import MoveParticipant from './routes/MoveParticipant'
import participantsReducer from './routes/ParticipantsPage/modules/Participants'
import participantReducer from './routes/CreateParticipant/modules/CreateParticipant'
import consentReducer from '../Consent/routes/ConsentEditor/modules/Consent'
import CreateCaregiverRoute from './routes/Caregiver/CreateCaregiver'
import ViewCaregiverRoute from './routes/Caregiver'

// Sync route definition
export default store => {
  injectReducers(store, {
    participants: participantsReducer,
    participantReducer,
    consentReducer,
  })

  const participantsPageRoute = ParticipantsPageRoute(store)

  return {
    path: 'participants',
    exact: true,
    indexRoute: {
      ...participantsPageRoute,
      getComponent(nextState, cb) {
        const { params } = nextState
        const { studyID } = params || {}
        const { currentStudy } = store.getState().study

        store.dispatch(setSubroute('participants'))
        setPageTitle(`Participants | Study ${studyID} | ${currentStudy?.platform_name ?? ''}`)
        participantsPageRoute.getComponent(nextState, cb)
      },
    },
    getChildRoutes(location, cb) {
      store.dispatch(setSubroute('participants'))
      const { user } = store.getState()
      if (isSameUser(user.id) ?? true) {
        cb(null, [
          CreateParticipantRoute(store),
          AccountSettingsRoute(store),
          ViewParticipantsRoute(store),
          CreateCohortRoute(store),
          ViewCohortRoute(store),
          MoveParticipant(store),
          CreateCaregiverRoute(store),
          ViewCaregiverRoute(store),
        ])
      } else browserHistory.push('/')
    },
  }
}
